// eslint-disable-next-line
import { RouteView } from '@/layouts'

export const goodsRouter = [
  {
    path: '/goods',
    redirect: '/goods/goodsList',
    component: RouteView,
    name:"Goods",
    meta: { title: '商品', keepAlive: true, icon: 'shopping' },
    children: [
      {
        path: '/goods/manager',
        redirect: '/goods/goodsList',
        component: RouteView,
        name:"GoodsManager",
        meta: { title: '商品管理', keepAlive: true },
        children: [
          {
            path: '/goods/goodsList',
            name: 'GoodsList',
            component: () => import('@/views/product/GoodsList'),
            meta: { title: '商品列表', keepAlive: true }
          },
          //第一期没有
          {
            path: '/goods/goodsGroup',
            name: 'GoodsGroups',
            component: () => import('@/views/product/GoodsGroups'),
            meta: {
              title: '商品分组', keepAlive: false,
              actions: [
                { key: 'add', permissionId: 'CreateProductGroup' },
                {
                  key: 'edit', permissionId: 'CreateProductGroup'
                },
                {
                  key: 'delete', permissionId: 'GoodsGroups'
                }
                ]
            }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/product/createProductGroup',
            name: 'CreateProductGroup',
            component: () => import('@/views/product/components/CreateProductGroup'),
            meta: { title: '创建商品分组', keepAlive: true, hideInMenu: true, hidePermissionTree: true }
          },
          {
            path: '/goods/offlineRecords',
            name: 'OfflineRecords',
            component: () => import('@/views/product/OfflineRecords'),
            meta: { title: '下架记录', keepAlive: true }
          },
          {
            hidden: true,//不显示在菜单上
            path: '/product/posterSet',
            name: 'PosterSet',
            component: () => import('@/views/product/PosterSet'),
            meta: { title: '海报设置', keepAlive: true, hideInMenu: true }
          }
        ]
      },
      {
        path: '/goods/manager',
        redirect: '/goods/directPurchase',
        component: RouteView,
        meta: { title: '采购/分销', keepAlive: true },
        name:"directPurchaseGroup",
        children: [
          // {
          //   path: '/goods/directPurchase',
          //   name: 'DirectPurchase',
          //   component: () => import('@/views/product/DirectPurchase'),
          //   meta: { title: '平台直采', keepAlive: false }
          // },
          {
            path: '/goods/supplyChain',
            name: 'SupplyChain',
            component: () => import('@/views/product/SupplyChain'),
            meta: { title: '蜗友AI旅链', keepAlive: false }
          }
        ]
      },
      {
        path: '/platform/resource',
        component: RouteView,
        name:"platformResourceGroup",
        meta: {
          title: '资源直连',
          keepAlive: true,
          icon: 'appstore'
        },
        children: [
          {
            path: '/platform/resource/zwy',
            name: 'ZwyHome',
            component: () => import('@/views/resource/zwy/ZwyHome.vue'),
            meta: {
              title: '自我游套餐直连',
              keepAlive: true
            }
          },
          {
            path: '/platform/resource/zwyRush',
            name: 'ZwyRushHome',
            component: () => import('@/views/resource/zwy/ZwyRushHome.vue'),
            meta: {
              title: '自我游抢购直连',
              keepAlive: true,
              ignorePermissions: true
            }
          },
          {
            path: '/platform/resource/ZwyCalendarRoom',
            name: 'ZwyCalendarRoom',
            component: () => import('@/views/resource/zwy/ZwyCalendarRoom.vue'),
            meta: {
              title: '自我游日历房直连',
              keepAlive: true,
            }
          },
          {
            path: '/platform/resource/sjcl',
            name: 'ShiJiHome',
            component: () => import('@/views/resource/shiji/Home.vue'),
            meta: {
              title: '石基畅联直连',
              keepAlive: true
            }
          },
          {
            path: '/platform/resource/dhqcl',
            name: 'DaHengQinHome',
            component: () => import('@/views/resource/dahengqin/Home.vue'),
            meta: {
              title: '大横琴资源直连',
              keepAlive: true
            }
          },
          {
            path: '/platform/resource/ctrip',
            name: 'CtripHome',
            component: () => import('@/views/resource/ctrip/Home.vue'),
            meta: {
              title: '携程代理通',
              keepAlive: true
            }
          },
          {
            path: '/platform/resource/qianqing',
            name: 'QianqingHome',
            component: () => import('@/views/resource/qianqing/Home.vue'),
            meta: {
              title: '千擎线路同步',
              keepAlive: true
            }
          },
          {
            path: '/platform/resource/sam',
            name: 'SamHome',
            component: () => import('@/views/resource/sam/Home.vue'),
            meta: {
              title: '山姆直连',
              keepAlive: true
            }
          },
          {
            path: '/platform/resource/disney',
            name: 'DisneyProductConfig',
            component: () => import('@/views/resource/disney/Home.vue'),
            meta: {
              title: '迪士尼产品配置',
              keepAlive: true
            }
          },
        ],
      },
    ]
  }
]
